import { applyMiddleware, createStore } from "redux"
import { initialKpiSales, kpiSales } from "../dashboard/sales/store"
import { initialKpiProduct, kpiProduct } from "../dashboard/product/store"
import { initialKpiRealTime, kpiRealTime } from "../dashboard/realTime/store"
import { initialKpiChecking, kpiChecking } from "../dashboard/checking/store"
import { initialKpiOrderIntegration, kpiOrderIntegration } from "../dashboard/orderIntegration/store"
import { initialKpiPaymentExclusion, kpiPaymentExclusion } from "../dashboard/paymentExclusion/store"
import { initialKpiPerformace, kpiPerformace } from "../dashboard/franchise/store"
import { initialKpiPerformaceTimeBySatus, kpiPerformaceTimeBySatus } from "../dashboard/performanceOperation/store"
import { setLoadingState } from "../dashboard/component/loading/store"
import { createToogleThemeMode, initialStateTheme } from "../dashboard/theme/store"
import { iniciarBusca, initialDashboardFilter, initialRealTimeProgress, initialTodaySlices, initialTrademarkFilter, updateDashboardFilter, updateProgress, updateTodaySlices, updateTrademarkFilter } from "../component/filter/store"
import { initialKpiCustomer, updateKpiCustomer } from "../dashboard/customer/store"
import { initialGeneralParameters, setGeneralParameters } from "../dashboard/parameter/store"
import { initialIssuingInvoices, updateIssuingInvoices } from "../gerencial/franchise-management/store/issuing-invoices"
import { initialFranchiseManagementConfig, updateFranchiseManagementConfig, initialFranchiseManagementConfigDialog, updateFranchiseManagementConfigDialog } from "../gerencial/franchise-management/store/config"
import { broadcastMiddleware, initBroadcastListener } from "../component/generic/iframes/broadcastMiddleware"

const INITIAL_STATE = {
    theme: initialStateTheme(),
    kpiSales: initialKpiSales(),
    kpiProduct: initialKpiProduct(),
    kpiCustomer: initialKpiCustomer(),
    kpiRealTime: initialKpiRealTime(),
    kpiChecking: initialKpiChecking(),
    // kpiFinancialPending: initialKpiFinancial(),
    kpiOrderIntegration: initialKpiOrderIntegration(),
    kpiPaymentExclusion: initialKpiPaymentExclusion(),
    kpiPerformace: initialKpiPerformace(),
    kpiPerformanceTimeBySatus: initialKpiPerformaceTimeBySatus(),
    loading: {},
    progress: initialRealTimeProgress(),
    todaySlices: initialTodaySlices(),
    trademark: initialTrademarkFilter(),
    dashboardFilter: initialDashboardFilter(),
    issuingInvoices: initialIssuingInvoices(),
    franchiseManagementConfig: initialFranchiseManagementConfig(),
    franchiseManagementConfigDialog: initialFranchiseManagementConfigDialog(),
    generalParameters: initialGeneralParameters(),
}

function reciveAction(state = INITIAL_STATE, action) {
    switch (action.type) {
        case 'TOGGLE_THEME_MODE':
            return createToogleThemeMode(state)
        case 'KPI_SALES':
            return kpiSales(state, action)
        case 'KPI_PRODUCT':
            return kpiProduct(state, action)
        case 'KPI_CUSTOMER':
            return updateKpiCustomer(state, action)
        case 'KPI_REALTIME':
            return kpiRealTime(state, action)
        case 'KPI_CHECKING':
            return kpiChecking(state, action)
        case 'KPI_ORDER_INTEGRATION':
            return kpiOrderIntegration(state, action)
        case 'KPI_PAYMENT_EXCLUSION':
            return kpiPaymentExclusion(state, action)
        case 'KPI_PERFORMANCE_STORE':
            return kpiPerformace(state, action)
        case 'KPI_PERFORMANCE_TIME_STATUS':
            return kpiPerformaceTimeBySatus(state, action)
        case 'LOGOUT_USER':
            // progress é recalculado para o dialog de filtros voltar a abrir no próximo login.
            return { ...INITIAL_STATE, dashboardFilter: initialDashboardFilter(), progress: initialRealTimeProgress() }
        case 'SET_LOADING': {
            return setLoadingState(state, action)
        }
        case 'UPDATE_PROGRESS': {
            return updateProgress(state, action)
        }
        case 'INICIAR_BUSCA':
            return iniciarBusca(state, action)
        case 'UPDATE_TODAY_SLICES':
            return updateTodaySlices(state, action)
        case 'UPDATE_TRADEMARK_FILTER':
            return updateTrademarkFilter(state, action)
        case 'UPDATE_DASHBOARD_FILTER':
            return updateDashboardFilter(state, action)
        case 'UPDATE_ISSUING_INVOICES':
            return updateIssuingInvoices(state, action)
        case 'UPDATE_FRANCHISE_MANAGEMENT_CONFIG':
            return updateFranchiseManagementConfig(state, action)
        case 'UPDATE_FRANCHISE_MANAGEMENT_CONFIG_DIALOG':
            return updateFranchiseManagementConfigDialog(state, action)
        case 'RESET_FRANCHISE_MANAGEMENT_CONFIG_DIALOG':
            return updateFranchiseManagementConfigDialog(state, { franchiseManagementConfigDialog: initialFranchiseManagementConfigDialog() })
        case 'SEND_GENERAL_PARAMETERS': {
            return setGeneralParameters(state, action)
        }
        default:
            return state
    }
}

const middlewares = [broadcastMiddleware]

const store = createStore(reciveAction, applyMiddleware(...middlewares))

initBroadcastListener(store)

export default store